module.exports = __webpack_public_path__ + "img/localizacao.be64987b.svg";